import { getPreviewVideoUrl } from "./service-preview-videos.js";

const OFFSET_X = 28;
const OFFSET_Y = 28;
const TRAIL_SPEED = 0.18;

export function initServicesCursorVideo() {
  if (window.matchMedia("(hover: none), (pointer: coarse)").matches) {
    return;
  }

  const container = document.getElementById("services-container");
  const preview = document.getElementById("cursorVideoPreview");
  const video = preview?.querySelector("video");

  if (!container || !preview || !video) {
    return;
  }

  let activeTrigger = null;
  let currentX = 0;
  let currentY = 0;
  let targetX = 0;
  let targetY = 0;
  let isVisible = false;

  function lerp(start, end, factor) {
    return start + (end - start) * factor;
  }

  function updatePosition() {
    if (isVisible) {
      currentX = lerp(currentX, targetX, TRAIL_SPEED);
      currentY = lerp(currentY, targetY, TRAIL_SPEED);
      preview.style.left = `${currentX}px`;
      preview.style.top = `${currentY}px`;
    }
    requestAnimationFrame(updatePosition);
  }

  function showPreview(trigger, clientX, clientY) {
    const url = getPreviewVideoUrl(trigger.dataset.previewVideo);
    if (!url) {
      return;
    }

    if (video.getAttribute("src") !== url) {
      video.src = url;
      video.load();
    }

    video.play().catch(() => {});

    currentX = clientX + OFFSET_X;
    currentY = clientY + OFFSET_Y;
    targetX = currentX;
    targetY = currentY;
    preview.classList.add("active");
    isVisible = true;
    activeTrigger = trigger;
  }

  function hidePreview() {
    isVisible = false;
    activeTrigger = null;
    preview.classList.remove("active");
    video.pause();
  }

  container.addEventListener("mouseover", (event) => {
    const trigger = event.target.closest(".service-hover-video");
    if (!trigger || !container.contains(trigger)) {
      return;
    }
    if (trigger === activeTrigger) {
      return;
    }
    showPreview(trigger, event.clientX, event.clientY);
  });

  container.addEventListener("mouseout", (event) => {
    const trigger = event.target.closest(".service-hover-video");
    if (!trigger || !container.contains(trigger)) {
      return;
    }
    const related = event.relatedTarget;
    if (related && trigger.contains(related)) {
      return;
    }
    if (activeTrigger === trigger) {
      hidePreview();
    }
  });

  container.addEventListener("mousemove", (event) => {
    if (!activeTrigger) {
      return;
    }
    targetX = event.clientX + OFFSET_X;
    targetY = event.clientY + OFFSET_Y;
  });

  document.addEventListener("languageChanged", hidePreview);
  requestAnimationFrame(updatePosition);
}

if (document.body.classList.contains("services")) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initServicesCursorVideo);
  } else {
    initServicesCursorVideo();
  }
}
